<div class="container-xxl text-center" style="padding-top: 10%">
    <h1 class="display-4">Ops! Pagina Non Trovata</h1>
    <p class="lead">Sembra che tu abbia preso una strada sbagliata.</p>
    <p class="mt-4">Ma non preoccuparti, puoi sempre tornare alla <a href="/">homepage</a>.</p>
</div>
